import auth from '@/plugin/store/auth'

export default {
  auth
}
